import Index from './Index'
import Show from './Show'
import StacksModal from './StacksModal'
import Overview from './Overview'
import Invoices from './Invoices'
import AwsAccounts from './AwsAccounts.vue'

export default {
    Index,
    Show,
    StacksModal,
    Overview,
    Invoices,
    AwsAccounts
}
